import { getLiveContextData } from './instantLoaded/tools';
import { isBank } from '@/config/core';
import { clearRecoveryData, recoveryRetainContext, redirectionTo } from './tools';
import { clearDataFromLocalStorage, getDataFromLocalStorage, saveDataToLocalStorage } from './bridges/localStorage';
import { v4 as uuidv4 } from 'uuid';
import { initStore } from '@/stores';
import { jsonToQueryString, parseQueryStringToObj } from './url-util';
import { isBankNonLogin } from './liveChatToken';
import coreStore from '@/stores/core';
import { type SessionStore } from '@/stores/session';
import { ILiveContextData, ILiveContextDataDialogue } from '@/types/revoceData';
import { SessionIDType } from './constants';
import { ButtonAction } from './getButtonData';
import { handleLiveBtnClick } from './btnClickHandler';

const retainSessionSuccessField = 'retainSessionSuccess';
export enum BankUrlSceneParamEnum {
  fromLoginPage = 'fromLoginPage',
}
export enum BankUrlMethodParamEnum {
  loginBtn = 'loginBtn',
  liveBtn = 'liveBtn',
  redirection = 'redirection'
}

let retainSessionContextSuccess = false;

export function isRetainSessionContextSuccess() {
  return isBank() && retainSessionContextSuccess;
}
/**
 *
 * @returns boolean - 是否retain成功
 */
export async function retainSessionContext(): Promise<boolean> {
  if (!isBank()) {
    retainSessionContextSuccess = false;
    return false;
  }

  // 从bank登录页back
  if (isLandingFromBankLoginPage()) {
    if (await retainSessionContextInternal()) {
      try {
        await tagRetainSession()
        const { default: firstInitStore, initSessionApiFinish } = await import('../stores/firstInit');
        console.log('[bankLoginHelpers]~retainSessionContextInternal, initSessionApiFinish', { initSessionApiFinish: typeof initSessionApiFinish });
        // firstInitStore.initApiPromise.then(() => console.log("initApiPromise then")).catch(() => console.log("initApiPromise catch"))
        initSessionApiFinish?.();
        // 关联消息
        console.log('[bankLoginHelpers]~retainSessionContextInternal, start to updateNoLoginMessage, data=', { session_id: initStore.sessionId });
        const { handleRequest } = await import('./index');
        handleRequest('updateNoLoginMessage', { session_id: initStore.sessionId });
        const urlQueries = parseRecoverParamsInBankSceneFromUrl();
        if (urlQueries) {
          excuteMethodAfterRetainMessage(urlQueries);
        }
      } catch (e) {
        console.error('[bankLoginHelpers]~retainSessionContext, e=', e);
      }
      retainSessionContextSuccess = true;
      return true;
    }
  }
  retainSessionContextSuccess = false;
  return false;
}

// async function removeNonLoginMessage() {
//     try {
//         const { default: sessionStore } = await import('../stores/session');
//         console.log('[bankLoginHelpers]~removeNonLoginMessage, initList=', sessionStore.initList)
//         sessionStore.REMOVE_INIT_DIALOGUE(0)
//     } catch (e) {
//         console.error('[bankLoginHelpers]~removeNonLoginMessage, e', e)
//     }
// }
async function retainSessionContextInternal(): Promise<boolean> {
  if (!isBank()) {
    return false;
  }
  let sessionStore: SessionStore | null = null;
  try {
    const { default: sessionStoreDyamnic } = await import('../stores/session');
    sessionStore = sessionStoreDyamnic;
    sessionStore.SHOW_LOADING();
    const recoverContextStr = await getLiveContextData();
    if (!recoverContextStr) {
      console.log('[bankLoginHelpers]~retainSessionContextInternal, data is empty');
      return false;
    }
    const contextData = JSON.parse(recoverContextStr);
    await hookIntoBeforeRecoveryRetainContext(contextData);
    console.log('[bankLoginHelpers]~retainSessionContextInternal, start to recoveryRetainContext');
    await recoveryRetainContext(contextData);
    // await removeNonLoginMessage();
    // 清除登录前的contextData
    console.log('[bankLoginHelpers]~retainSessionContextInternal, start to clearRecoveryData');
    clearRecoveryData();
    return true;
  } catch (e) {
    console.error('[bankLoginHelpers]~retainSessionContextInternal, e=', e);
  } finally {
    if (sessionStore) {
      sessionStore?.HIDE_LOADING();
    }
  }

  return false;
}

async function tagRetainSession() {
  const hash = location.hash;
  if (!hash || hash !== `#${retainSessionSuccessField}`) {
    location.hash = retainSessionSuccessField;
  }
  console.log('tagRetainSession', location.hash)
}

function tryRemoveTFEDialogLoginBtn(dialog: ILiveContextDataDialogue) {
  if (!dialog) {
    return;
  }
  const { sessionId, tfNodeId, nodePointId, data } = dialog;
  if (sessionId && tfNodeId && nodePointId) {
    const buttons = data?.buttonGroup?.buttons;
    if (buttons?.length) {
      for (let i = 0; i < buttons.length; i++) {
        const button = buttons[i];
        if (button.action?.action_type === ButtonAction.Login && button.action?.task_bot_action) {
          // remove
          buttons.splice(i, 1);
          i--;
        }
      }
    }
  }
}
function tryRemoveLoginBtn(dialog: ILiveContextDataDialogue) {
  if (!dialog) {
    return;
  }
  if (dialog.data?.buttonGroup?.buttons) {
    const buttons = dialog.data?.buttonGroup?.buttons;
    const loginBtn = buttons?.[0] as any;
    if (loginBtn?.action && loginBtn.action?.__tag__?.by === 'addBankToLoginDialogue') {
      loginBtn.hidden = true;
      if (buttons?.length) {
        if (loginBtn) {
          buttons.splice(0, 1)
        }
      }
    }
  }
}
async function hookIntoBeforeRecoveryRetainContext(contextData: Partial<ILiveContextData>) {
  try {
    if (contextData && typeof contextData === 'object' && !Array.isArray(contextData)) {
      const {
        sessionIDList = [],
        chatbotHistory = {} as ILiveContextData['chatbotHistory'],
      } = contextData;
      // 恢复历史记录
      let dialoueList: ILiveContextDataDialogue[] = [];
      sessionIDList.forEach((idItem) => {
        const { type, id } = idItem;
        if (!id) {
          return;
        }
        switch (type) {
          case SessionIDType.CHAT_BOT: {
            if (Array.isArray(chatbotHistory[id])) {
              dialoueList = chatbotHistory[id];
            }
          }
            break;
          default:
        }
      });

      if (Array.isArray(dialoueList)) {
        dialoueList.forEach((dialogue) => {
          try {
            tryRemoveTFEDialogLoginBtn(dialogue);
            tryRemoveLoginBtn(dialogue)
          } catch (e) {
            console.error("hookIntoBeforeRecoveryRetainContext", e)
          }
        });
      }
    }

  } catch (e) {
    console.error('[bankLoginHelpers]~hookIntoBeforeRecoveryRetainContext, e=', e);
  }
}

export function generateMethodId(name: string) {
  // NOTE: 这里默认同时只有一种触发的登录的方式
  // 各个method公用一个methodId
  // return `chatbot-methodid-${uuidv4()}`
  return `chatbot-methodid-${name || uuidv4()}`;
}

export async function saveMethodDataById(methodId: string, methodData: Record<string, any> | IRedirectionMethodData) {
  console.log('[bankLoginHelpers]~saveMethodDataById, data=', {
    methodId,
    methodData
  });
  if (!methodId) {
    return;
  }

  return saveDataToLocalStorage(methodId, methodData);
}

export async function getMethodDataById(methodId: string): Promise<string | null> {
  console.log('[bankLoginHelpers]~getMethodDataById, data=', { methodId, });
  if (!methodId) {
    return null;
  }

  return getDataFromLocalStorage(methodId);
}


export async function clearMethodDataById(methodId: string) {
  console.log('[bankLoginHelpers]~clearMethodDataById, data=', { methodId, });
  if (!methodId) {
    return;
  }

  return clearDataFromLocalStorage(methodId);
}

export interface IRedirectionMethodData {
  link: string;
}

export interface ILiveBtnMethodData {
  liveClickInfo: any;
}

const methodMapping: {
  [key: string]: (options: {
    retainParams: IBankLoginSceneParams
  }) => Promise<any>
} = {
  [BankUrlMethodParamEnum.loginBtn]: async function loginBtnMthod({ retainParams }) {
    if (!retainParams?.methodId) {
      console.log('[bankLoginHelpers]~loginBtnMthod, methodId is empty, data=', { retainParams });
      return;
    }

    try {
      const methodData = await getMethodDataById(retainParams.methodId);
      if (!methodData) {
        console.log('[bankLoginHelpers]~loginBtnMthod, methodData is empty');
        return;
      }

      console.log('[bankLoginHelpers]~loginBtnMthod, methodData=', methodData);
      const { handleRequest } = await import('./index');
      await handleRequest('postMessage', JSON.parse(methodData));
    } catch (e) {
      console.error('[bankLoginHelpers]~loginBtnMthod, e=', e);
    }
  },
  [BankUrlMethodParamEnum.redirection]: async function redirectionMethod({ retainParams }) {
    if (!retainParams?.methodId) {
      console.log('[bankLoginHelpers]~redirectionMethod, methodId is empty, data=', { retainParams });
      return;
    }

    try {
      const methodData = await getMethodDataById(retainParams.methodId);
      if (!methodData) {
        console.log('[bankLoginHelpers]~redirectionMethod, methodData is empty');
        return;
      }

      console.log('[bankLoginHelpers]~redirectionMethod, methodData=', methodData);
      if (typeof methodData === 'string') {
        const redirecionLinkData = JSON.parse(methodData) as IRedirectionMethodData;
        if (redirecionLinkData?.link) {
          // bank will open, so chatbot won't do
          // redirectionTo(redirecionLinkData?.link);
          console.log('[bankLoginHelpers]~redirectionMethod, trigger by link: ', redirecionLinkData?.link);
        }
      }
    } catch (e) {
      console.error('[bankLoginHelpers]~redirectionMethod, e=', e);
    }
  },
  [BankUrlMethodParamEnum.liveBtn]: async function liveBtnMethod({ retainParams }) {
    if (!retainParams?.methodId) {
      console.log('[bankLoginHelpers]~liveBtnMethod, methodId is empty, data=', { retainParams });
      return;
    }

    try {
      const methodData = await getMethodDataById(retainParams.methodId);
      if (!methodData) {
        console.log('[bankLoginHelpers]~liveBtnMethod, methodData is empty');
        return;
      }

      console.log('[bankLoginHelpers]~liveBtnMethod, methodData=', methodData);
      console.log('[bankLoginHelpers]~liveBtnMethod, liveBtnInfo=');
      if (typeof methodData === 'string') {
        const liveBtnInfo = JSON.parse(methodData) as ILiveBtnMethodData;
        console.log('[bankLoginHelpers]~liveBtnMethod, liveBtnInfo=', liveBtnInfo);
        if (liveBtnInfo?.liveClickInfo) {
          console.log('[bankLoginHelpers]~liveBtnMethod', liveBtnInfo?.liveClickInfo);
          handleLiveBtnClick(liveBtnInfo?.liveClickInfo)
        }
      }
    } catch (e) {
      console.error('[bankLoginHelpers]~liveBtnMethod, e=', e);
    }
  }
};
async function excuteMethodAfterRetainMessage(retainParams: IBankLoginSceneParams) {
  console.log('[bankLoginHelpers]~excuteMethodAfterRetainMessage, retainParams=', { retainParams });
  if (!isBank()) {
    return;
  }
  if (!retainParams || !retainParams.method) {
    return;
  }

  console.log('[bankLoginHelpers]~excuteMethodAfterRetainMessage, fullStorePromise');
  await coreStore.fullStorePromise;
  console.log('[bankLoginHelpers]~excuteMethodAfterRetainMessage, fullStorePromise');

  const methodHanlder = methodMapping[retainParams.method];
  if (!methodHanlder) {
    if (retainParams.methodId) {
      clearMethodDataById(retainParams.methodId);
    }
    console.warn('[bankLoginHelpers]~excuteMethodAfterRetainMessage, unknown method');
    return;
  }

  setTimeout(async () => {
    try {
      await methodHanlder({ retainParams });
      if (retainParams.methodId) {
        clearMethodDataById(retainParams.methodId);
      }
    } catch (e) {
      console.error('[bankLoginHelpers]~excuteMethodAfterRetainMessage, methodHanlder, e=', e);
    }
  }, 0);
}

export type IBankLoginSceneParams = {
  scene?: BankUrlSceneParamEnum | '',
  method?: BankUrlMethodParamEnum | '',
  methodId?: string;
} | null
export function parseRecoverParamsInBankSceneFromUrl(): IBankLoginSceneParams {
  // if (process.env.NODE_ENV === 'development') {
  //   return {
  //     scene: BankUrlSceneParamEnum.fromLoginPage,
  //     method: BankUrlMethodParamEnum.redirection,
  //     methodId: generateMethodId(BankUrlMethodParamEnum.redirection)
  //   };
  // }
  if (!isBank()) {
    return null;
  }
  const query = parseQueryStringToObj(window.location.search);
  /** @type {string|BankUrlMethodParamEnum} scene - 打开页面的referrer */
  const scene = query.scene as BankUrlSceneParamEnum | '';
  /** @type {string|BankUrlMethodParamEnum} method - 触发登录的原因 */
  const method = query.method as BankUrlMethodParamEnum | '';
  /** @type {string} methodId - 额外数据的存储id */
  const methodId = query.methodId as string | undefined;
  return {
    scene,
    method,
    methodId,
  };
}

export function isLandingFromBankLoginPage() {
  if (!isBank() && !isBankNonLogin) {
    return false;
  }
  const urlQueries = parseRecoverParamsInBankSceneFromUrl();

  if (urlQueries?.scene === BankUrlSceneParamEnum.fromLoginPage && location.hash !== `#${retainSessionSuccessField}`) {
    return true;
  }

  return false;
}
